import React from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  getDefaultProps,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  BlockType,
  FCPrimaryBlock,
} from "@kameleon-core/lib";

import GridMedia from "@kameleon-section/content-two-col-grid-media-v1";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { ContentType, layoutOptions } from "./types/prop-types";

/** Content Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Small,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockType: BlockType.Primary,
  blockTheme: BlockTheme.light,
};

const GridMediaComponent = GridMedia.component as FCPrimaryBlock<any>;

export const Content = primaryBlock<ContentType>(
  blockConfig,
  ({ ...props }: ContentType) => (
    <GridMediaComponent
      className="primary-content-two-col-grid-color-v1"
      {...props}
    />
  )
);

Content.defaultProps = getDefaultProps<ContentType>(defaults);

export const Element: KameleonElement = {
  component: Content,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
